import { Link } from "react-router-dom";

import Services from "../components/Services";
import StatsSection from "../components/StatsSection";
import Products from "../components/Products";
import Industries from "../components/Industries";
import Testimonial from "../components/Testimonial";

function Servicepage() {
  return (
    <>
	<section className="page-title custom-breadcrumb">
		<div className="overlay"></div>
		<div className="auto-container">
			<div className="content-box">
				<h1>Services</h1>
				<ul className="bread-crumb"><li><Link to="/">Home</Link></li><li><span>→</span></li><li className="active">Services</li></ul>
			</div>
		</div>
	</section>	
		
		<Services />
		<StatsSection />
		<Products />
		<Industries />
		<Testimonial />
    </>
  );
}

export default Servicepage;